import classNames from 'classnames';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, ButtonProps } from 'yoso';
import styles from './BackButton.module.scss';

export type BackButtonProps = ButtonProps;
export const BackButton = ({ className, onClick, ...props }: BackButtonProps) => {
  const history = useHistory();
  const handleClick = useCallback(
    (e) => {
      history.goBack();
      onClick?.(e);
    },
    [history, onClick]
  );
  return (
    <Button
      className={classNames(styles.root, className)}
      onClick={handleClick}
      variant="transparent"
      {...props}>
      <svg
        className={styles.icon}
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.5002 4.8934L7.89355 14.5L17.5002 24.1066"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    </Button>
  );
};
